enum MainTaskStatus {
    // [Description("待完成")],
    'AwaitAccomplish' = 1, // daiwancheng
    // [Description("已完成")]
    'AlreadyAccomplish' = 2,
    // [Description("已逾期")]
    'AlreadyOverdue' = 3
}

const PersonType = [
    { label: '所有角色', value: 0 },
    { label: '物业管理员', value: 1 },
    { label: '维保管理员', value: 2 },
    { label: '物业员工', value: 3 },
    { label: '维保技师', value: 4 }
]

const PersonTypeTable = [
    { label: '无角色', value: 10 },
    { label: '物业管理员', value: 1 },
    { label: '维保管理员', value: 2 },
    { label: '物业员工', value: 3 },
    { label: '维保技师', value: 4 }
]

const propertyRole = [
    // { label: '所有角色', value: 0 },
    { label: '保洁员', value: 1 },
    { label: '巡检员', value: 2 },
    { label: '宿管员', value: 3 },
    { label: '物业管理员', value: 4 },
    { label: '工程师', value: 5 },
    { label: '认证用户', value: 6 }
    // { label: '暂无职务', value: 10 }
]

const templateType = [
    { label: '半月维保', value: 1 },
    { label: '季度维保', value: 2 },
    { label: '半年维保', value: 3 },
    { label: '年度维保', value: 4 },
]

const subTaskStatus = [
    { label: '全部任务状态', value: 0 },
    { label: '待维保', value: 1 },
    { label: '已维保', value: 2 },
    { label: '待签字', value: 3 },
    { label: '已签字', value: 4 },
    { label: '已逾期', value: 5 },
    { label: '未发送', value: 6 },
    { label: '已关闭', value: 7 },
    { label: '暂未维保', value: 10 }
]
const rescueTaskStatus = [
    { label: '所有状态', value: 0 },
    { label: '待接单', value: 11 },
    { label: '待救援', value: 12 },
    { label: '救援中', value: 13 },
    { label: '救援完成', value: 14 }
]

const elevatorStatus = [
  { label: '异常', value: 1 },
  { label: '修理', value: 2 },
  { label: '正常', value: 3 },
]

const messageType = [
    { label: '全部类型', value: 0 },
    { label: '维保任务单', value: 1 },
    { label: '物业签字单', value: 2 },
    { label: '已完成任务单', value: 3 },
    { label: '用户取关通知', value: 4 },
    { label: '维保逾期单', value: 5 },
    { label: '汇报单', value: 6 },
    {label: '维保异常单', value: 7 },
    {label: '周报', value: 8 },
    {label: '月报', value: 9 },
    {label: '测试', value: 10 },
    { label: '关人故障通知', value: 11 },
    { label: '接单通知', value: 12 },
    { label: '开始救援通知', value: 13 },
    { label: '救援完成通知', value: 14 },
    { label: '接单超时通知', value: 15 },
    { label: '救援超时通知', value: 16 },
    { label: '维修任务通知单', value: 21 },
    { label: '故障维修进度通知', value: 22 },
    { label: '维修完成通知', value: 23 },
    { label: '故障维修签字单', value: 24 },
    { label: '保洁超时通知', value: 31 },
    { label: '保洁异常通知', value: 32 },
    { label: '保洁进度通知', value: 33 },
    { label: '保洁未完成提醒', value: 34 },
    { label: '保洁完成提醒', value: 35 },
    { label: '项目到期提醒', value: 40 },
    { label: '电梯年检提醒', value: 41 },
    { label: '应收款提醒', value: 42 },
    { label: '应收款到期提醒', value: 43 },
    { label: '取消维保通知', value: 44 }
]

const MessageStatus = [
    { label: '全部状态', value: 0 },
    { label: '未发送', value: 1 },
    { label: '发送成功', value: 2 },
    { label: '发送失败', value: 3 },
    { label: '已送达', value: 4 },
    { label: '未送达', value: 5 }
]

const elevatorType = [
    { label: '曳引与强制驱动电梯', value: 1 },
    { label: '液压驱动电梯', value: 2 },
    { label: '杂物电梯', value: 3 },
    { label: '自动扶梯', value: 4 },
    { label: '自动人行道', value: 5 },
]
const areaType = [
    {label: '保洁', value: 1 },
    {label: '保洁巡检', value: 2 },
    {label: '宿舍查寝', value: 3 },
    {label: '设备报修', value: 4 },
    {label: '设备巡检', value: 5 }
]
const projectPaymentType = [
    // { label: '全部', value: 0 },
    { label: '月付', value: 1 },
    { label: '季付', value: 2 },
    { label: '半年', value: 3 },
    { label: '年付', value: 4 },
    { label: '一次性', value: 5 },
    { label: '免保', value: 6 },
]

const projectStatus = [
    { label: '新签', value: 1 },
    { label: '续签', value: 2 },
    { label: '到期', value: 3 },
    { label: '提前终止', value: 4 }
]

const organizationStatus = [
  { label: '生效', value: 1 },
  { label: '冻结', value: 2 },
  { label: '失效', value: 3 },
]


export { MainTaskStatus, PersonType, PersonTypeTable, propertyRole, templateType, subTaskStatus,
     elevatorStatus, messageType, MessageStatus, elevatorType, areaType, rescueTaskStatus, projectPaymentType, organizationStatus }
